import * as tslib_1 from "tslib";
import { HttpEventType, } from '@angular/common/http';
import { OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { MLPackageStatus, MLProcessor, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { MAX_NUMBER_OF_RESULTS } from '@pages/shared/constants';
import { MLPackagesService, MLPackageVersionsService, MLSkillsService, } from '@services';
import UiValidators, { UI_DESCRIPTION_MAX_LENGTH, UI_NAME_MAX_LENGTH, } from '@validators';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject, of, throwError, } from 'rxjs';
import { catchError, finalize, map, share, tap, } from 'rxjs/operators';
var MLSkillsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MLSkillsModalComponent, _super);
    function MLSkillsModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this.resultSize = MAX_NUMBER_OF_RESULTS;
        _this.processorTypes = [];
        _this._mlpackagesService = _this._injector.get(MLPackagesService);
        _this._mlpackageversionsService = _this._injector.get(MLPackageVersionsService);
        _this._mlskillsService = _this._injector.get(MLSkillsService);
        _this._translateService = _this._injector.get(TranslateService);
        _this.mlskillSearchFactory = function (query, top, skip) {
            if (query === void 0) { query = ''; }
            if (top === void 0) { top = MAX_NUMBER_OF_RESULTS; }
            if (skip === void 0) { skip = 0; }
            var queryOptions = {
                orderBy: ['Name asc'],
                filter: {
                    Name: {
                        contains: query,
                    },
                },
                skip: skip,
                top: top,
            };
            return _this._mlpackagesService
                .get(queryOptions)
                .pipe(map(function (response) { return _this._filterAndMapDeployableMLPackages(response.data); }), map(function (models) { return ({
                data: models,
                total: models.length,
            }); }));
        };
        _this._filterAndMapDeployableMLPackageVersions = function (models) {
            return models
                .filter(function (model) { return _this._canDeployPackage(model.status); })
                .map(function (model) {
                return {
                    id: model.id,
                    text: String(model.version),
                    data: model,
                };
            });
        };
        _this._filterAndMapDeployableMLPackages = function (models) {
            return models
                .filter(function (model) { return _this._canDeployPackage(model.status); })
                .map(function (model) {
                return {
                    id: model.id,
                    text: model.name,
                };
            });
        };
        return _this;
    }
    Object.defineProperty(MLSkillsModalComponent.prototype, "selectedMLSkill", {
        get: function () {
            return this.context.data.modelId ?
                {
                    id: this.context.data.modelId,
                    text: this.context.data.modelId,
                } :
                null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLSkillsModalComponent.prototype, "selectedType", {
        get: function () {
            var _this = this;
            return this.processorTypes.filter(function (processorType) { return processorType.id === _this.context.data.processor; });
        },
        enumerable: true,
        configurable: true
    });
    MLSkillsModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Currently only CPU is supported
        this.processorTypes = [MLProcessor.CPU]
            .map(function (processor) { return ({
            id: processor,
            text: processor,
        }); });
        this.context.data.processor = MLProcessor[this.processorTypes[0].text];
        this.form = this._injector.get(FormBuilder).group({
            'modelId': [
                [this.selectedMLSkill],
                UiValidators.required(),
            ],
            'modelVersionId': [
                [], function (c) {
                    return _this.selectedMLSkill == null ? null : UiValidators.required()(c);
                },
            ],
            'name': [
                '',
                [Validators.maxLength(UI_NAME_MAX_LENGTH), UiValidators.required()],
            ],
            'processor': [
                [this.context.data.processor],
                UiValidators.required(),
            ],
            'description': [
                '',
                Validators.maxLength(UI_DESCRIPTION_MAX_LENGTH),
            ],
        });
    };
    MLSkillsModalComponent.prototype.fetchModelVersions = function () {
        var _this = this;
        var queryOptions = {
            orderBy: ['Version desc'],
        };
        this.models$ = this._mlpackageversionsService
            .getVersions(this.context.data.modelId, queryOptions)
            .pipe(map(function (result) {
            return !result || !result.total ?
                [] :
                _this._filterAndMapDeployableMLPackageVersions(result.data);
        }), tap(function (models) {
            if (models && models.length > 0) {
                _this.form.patchValue({ 'modelVersionId': [models[0]] });
                _this.onVersionSelect(models[0]);
            }
            else {
                _this.form.patchValue({ 'modelVersionId': [] });
            }
        }), share());
    };
    MLSkillsModalComponent.prototype.onSubmit = function (_ev) {
        var _this = this;
        if (_ev) {
            _ev.preventDefault();
            _ev.stopImmediatePropagation();
        }
        this.loading$.next(true);
        var payload = cloneDeep(this.context.data);
        payload.description = this.form.get('description').value;
        payload.name = this.form.get('name').value.trim();
        this._mlskillsService.createMLSkill(payload, this._selectedMLPackageVersionId)
            .pipe(finalize(function () { return _this.loading$.next(false); }), catchError(function (error) {
            if (error.error && error.error.respMsg) {
                _this._snack.error(_this._translateService.instant("mlskill_creation_generic_failure", {
                    errorMessage: error.error.respMsg,
                }));
                return of(error);
            }
            return throwError(error);
        }))
            .subscribe(function (ev) {
            if (ev.type === HttpEventType.Response) {
                _this._dialogRef.close({
                    type: 1 /* Add */,
                });
            }
        });
    };
    MLSkillsModalComponent.prototype.onVersionSelect = function (value) {
        this.context.data.currentVersion = value.data.version;
        this._selectedMLPackageVersionId = value.data.id;
    };
    MLSkillsModalComponent.prototype._canDeployPackage = function (packageStatus) {
        return packageStatus.toLowerCase() === MLPackageStatus.Undeployed.toLowerCase() ||
            packageStatus.toLowerCase() === MLPackageStatus.Deployed.toLowerCase() ||
            packageStatus.toLowerCase() === MLPackageStatus.Deploying.toLowerCase() ||
            packageStatus.toLowerCase() === MLPackageStatus.Available.toLowerCase();
    };
    return MLSkillsModalComponent;
}(UiModalComponent));
export { MLSkillsModalComponent };
